import { FC } from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { Edit, Delete } from '@mui/icons-material';
import { Button, Card, CardContent, Grid, Typography } from '@mui/material';
import { IChecklistTemplateDetailWorkItem } from '../../../models';
import { DragIndicator } from '@mui/icons-material';

interface ICheckListWorkItem {
  catagoryName: string;
  setCurrentWorkItemIndex: (val: number | null) => void;
  workItems: IChecklistTemplateDetailWorkItem[];
  setFieldValue: (key: string, val: any) => void;
  workItem: IChecklistTemplateDetailWorkItem;
  itemIndex: number;
  isDragging: boolean;
}

export const CheckListWorkItem: FC<ICheckListWorkItem> = ({
  catagoryName,
  setFieldValue,
  itemIndex,
  workItems,
  workItem,
  setCurrentWorkItemIndex,
  isDragging
}) => {
  const classes = useStyles();
  return (
    <Card
      className={classes.card}
      sx={{
        backgroundColor: theme =>
          isDragging ? theme.palette.grey[300] : theme.palette.background.paper
      }}
    >
      <CardContent className={classes.cardContent}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item xs={1}>
            <DragIndicator color="action" />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography className={classes.bold}>Category</Typography>
            <Typography className={classes.value}>{catagoryName}</Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography className={classes.bold}>Description</Typography>
            <Typography className={classes.value}>{workItem.description}</Typography>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.actionButtons}>
              <Button
                color="primary"
                className={classes.editButton}
                startIcon={<Edit />}
                onClick={() => {
                  setCurrentWorkItemIndex(itemIndex);
                }}
              >
                Edit
              </Button>
              <Button
                id="delete"
                className={classes.deleteButton}
                startIcon={<Delete />}
                onClick={async () => {
                  const result = window.confirm('Are you sure you want to delete this work item?');
                  if (result) {
                    const newValues = [...workItems];
                    const filtered = newValues.filter(w => w.description !== workItem.description);
                    setFieldValue(`workItems`, filtered);
                  }
                }}
              >
                Delete
              </Button>
            </div>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  actionButtons: {
    textAlign: 'right',
    marginTop: 12,
    [theme.breakpoints.up('md')]: {
      marginTop: 0
    }
  },
  editButton: {
    textAlign: 'right',
    fontSize: 13
  },
  deleteButton: {
    marginLeft: theme.spacing(0.5),
    color: theme.palette.error.main
  },
  card: {
    width: '100%',
    marginTop: 8,
    marginBottom: 8,
    position: 'relative',
    zIndex: 1500
  },
  cardContent: {
    padding: `12px !important`
  },
  bold: {
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    fontSize: 12
  },
  value: {
    fontSize: 15
  }
}));
